// extracted by mini-css-extract-plugin
export var childrenContainer = "_5b-0";
export var virtualScrollArea = "_5b-1";